// Hook surface for the Deep Research engine. Components are encouraged
// to consume these instead of touching the store directly.

import { useResearch } from "@/store/researchStore";

export function useDeepResearch() {
  const enabled = useResearch((s) => s.enabled);
  const setEnabled = useResearch((s) => s.setEnabled);
  const status = useResearch((s) => s.status);
  const query = useResearch((s) => s.query);
  const dossier = useResearch((s) => s.dossier);
  const metrics = useResearch((s) => s.metrics);
  const guardrails = useResearch((s) => s.guardrails);
  const setGuardrails = useResearch((s) => s.setGuardrails);
  const start = useResearch((s) => s.start);
  const pause = useResearch((s) => s.pause);
  const resume = useResearch((s) => s.resume);
  const rollback = useResearch((s) => s.rollback);
  const stop = useResearch((s) => s.stop);
  const reset = useResearch((s) => s.reset);
  const selectedCitation = useResearch((s) => s.selectedCitation);
  const setSelectedCitation = useResearch((s) => s.setSelectedCitation);

  const isRunning = status === "planning" || status === "swarming" || status === "critiquing" || status === "synthesizing";
  const isPaused = status === "paused";

  return {
    enabled, setEnabled,
    status, query, dossier, metrics, guardrails, setGuardrails,
    start, pause, resume, rollback, stop, reset,
    isRunning, isPaused,
    selectedCitation, setSelectedCitation,
  };
}
